import ManualBillingDocumentKind from '@/generated/controls/manualBillingDocument/ManualBillingDocumentKind.vue';
import { ManualBillingDocumentKinds } from '@/generated/classes/ManualBillingDocument';
import { defineComponent } from 'vue';
import Item from '@/framework/base/classes/Item';
import { FieldStatus } from '@/framework/base/components/FieldInfo';

export default defineComponent({
  components: {},
  extends: ManualBillingDocumentKind,

  data() {
    const items: Item[] = [
      { key: ManualBillingDocumentKinds.INVOICE, title: 'Facture' },
      { key: ManualBillingDocumentKinds.CREDIT_NOTE, title: 'Avoir' },
      { key: ManualBillingDocumentKinds.CREDIT, title: 'Note de crédit' },
      { key: ManualBillingDocumentKinds.DEBIT, title: 'Note de débit' },
    ];
    return {
      initValue: 0,
      lastContextId: 0,
      status: new FieldStatus(false, false, 0),
      items,
    };
  },
});
